<template>
 <GameSelector />
</template>

<script>
import { GameSelector } from '../components'
export default {
    name: 'Index',

    components: {
        GameSelector
    },
}
</script>

<style>

</style>